import "./style.css";
import ButtonCom from "../../../components/button/button";
import verificationImg from "../../../assets/Images/balnk-page/verified.png";

const BackgroundVerification = () => {
  const handlePopUp = () => {};
  return (
    <div className="body-container">
      <div className="page-body">
        <div className="empty-content">
          <img src={verificationImg} alt="empty-page-icon" />
          <p>Background Verification</p>
        </div>
      </div>
    </div>
  );
};

export default BackgroundVerification;
